import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export class ValidarRedefinirSenhaProps {
    public constructor(
        public telefone: string = '',
        public email: string = '',
        public cpfCnpj: string = '',
        public redefinirCodigo: string = '',
    ) { }
}

export function usePostValidarRedefinirSenha() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postValidarRedefinirSenha = useCallback(
        (confirmarProps: ValidarRedefinirSenhaProps) =>
            invocarApi({
                url: `/v4/Auth/validar-redefinir-senha`,
                method: 'POST',
                data: confirmarProps,
                enviarTokenUsuario: false
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postValidarRedefinirSenha,
    };
}
